import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestStatsCustomBypassGet = {
    path: "/stats/customBypass",
    method: RouteHttpVerb.GET
};
export { locationRestStatsCustomBypassGet };
